var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _VaryingTempoMap_instances, _VaryingTempoMap_adapter, _VaryingTempoMap_absoluteSecondsToPPQN;
import { PPQN, TempoChangeGrid } from "@opendaw/lib-dsp";
import { quantizeCeil, Terminator } from "@opendaw/lib-std";
/**
 * TempoMap implementation that handles varying tempo (tempo automation).
 * Steps through at TempoChangeGrid intervals to match BlockRenderer behavior.
 */
export class VaryingTempoMap {
    constructor(adapter) {
        _VaryingTempoMap_instances.add(this);
        _VaryingTempoMap_adapter.set(this, void 0);
        __classPrivateFieldSet(this, _VaryingTempoMap_adapter, adapter, "f");
    }
    getTempoAt(position) {
        const storageBpm = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.getValue();
        return __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").tempoTrackEvents.mapOr(collection => collection.valueAt(position, storageBpm), storageBpm);
    }
    ppqnToSeconds(position) {
        if (position < 0) {
            return -this.intervalToSeconds(position, 0);
        }
        return this.intervalToSeconds(0, position);
    }
    secondsToPPQN(time) {
        return __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_absoluteSecondsToPPQN).call(this, time);
    }
    intervalToSeconds(fromPPQN, toPPQN) {
        if (fromPPQN >= toPPQN) {
            return 0.0;
        }
        const storageBpm = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.getValue();
        const tempoEvents = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").tempoTrackEvents;
        if (tempoEvents.isEmpty()) {
            return PPQN.pulsesToSeconds(toPPQN - fromPPQN, storageBpm);
        }
        const collection = tempoEvents.unwrap();
        if (collection.events.isEmpty()) {
            return PPQN.pulsesToSeconds(toPPQN - fromPPQN, storageBpm);
        }
        let totalSeconds = 0.0;
        let currentPPQN = fromPPQN;
        while (currentPPQN < toPPQN) {
            const currentBpm = collection.valueAt(currentPPQN, storageBpm);
            const nextGrid = quantizeCeil(currentPPQN, TempoChangeGrid);
            const segmentEnd = nextGrid <= currentPPQN ? nextGrid + TempoChangeGrid : nextGrid;
            const actualEnd = Math.min(segmentEnd, toPPQN);
            totalSeconds += PPQN.pulsesToSeconds(actualEnd - currentPPQN, currentBpm);
            currentPPQN = actualEnd;
        }
        return totalSeconds;
    }
    intervalToPPQN(fromSeconds, toSeconds) {
        if (fromSeconds >= toSeconds) {
            return 0.0;
        }
        // Find PPQN positions for both absolute times, return the difference
        const fromPPQN = __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_absoluteSecondsToPPQN).call(this, fromSeconds);
        const toPPQN = __classPrivateFieldGet(this, _VaryingTempoMap_instances, "m", _VaryingTempoMap_absoluteSecondsToPPQN).call(this, toSeconds);
        return toPPQN - fromPPQN;
    }
    subscribe(observer) {
        const terminator = new Terminator();
        terminator.ownAll(__classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.subscribe(() => observer(this)), __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").catchupAndSubscribeTempoAutomation(() => observer(this)));
        return terminator;
    }
}
_VaryingTempoMap_adapter = new WeakMap(), _VaryingTempoMap_instances = new WeakSet(), _VaryingTempoMap_absoluteSecondsToPPQN = function _VaryingTempoMap_absoluteSecondsToPPQN(targetSeconds) {
    if (targetSeconds <= 0) {
        return 0.0;
    }
    const storageBpm = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").box.bpm.getValue();
    const tempoEvents = __classPrivateFieldGet(this, _VaryingTempoMap_adapter, "f").tempoTrackEvents;
    if (tempoEvents.isEmpty()) {
        return PPQN.secondsToPulses(targetSeconds, storageBpm);
    }
    const collection = tempoEvents.unwrap();
    if (collection.events.isEmpty()) {
        return PPQN.secondsToPulses(targetSeconds, storageBpm);
    }
    let accumulatedSeconds = 0.0;
    let accumulatedPPQN = 0.0;
    while (accumulatedSeconds < targetSeconds) {
        const currentBpm = collection.valueAt(accumulatedPPQN, storageBpm);
        const nextGrid = quantizeCeil(accumulatedPPQN, TempoChangeGrid);
        const segmentEnd = nextGrid <= accumulatedPPQN ? nextGrid + TempoChangeGrid : nextGrid;
        const segmentPPQN = segmentEnd - accumulatedPPQN;
        const segmentSeconds = PPQN.pulsesToSeconds(segmentPPQN, currentBpm);
        if (accumulatedSeconds + segmentSeconds >= targetSeconds) {
            const remainingSeconds = targetSeconds - accumulatedSeconds;
            accumulatedPPQN += PPQN.secondsToPulses(remainingSeconds, currentBpm);
            break;
        }
        accumulatedSeconds += segmentSeconds;
        accumulatedPPQN = segmentEnd;
    }
    return accumulatedPPQN;
};
